// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3RlWw","actions":"GroupTable_actions__3tJvz","deleteModalFooter":"GroupTable_deleteModalFooter__1PWie"};